import { useState, useEffect } from 'react';
import { UserPacks } from '../types/premium';

const STORAGE_KEY = 'tentospin_premium_packs';

const defaultPacks: UserPacks = {
  luckySpins: 0,
  highRollerSpins: 0,
  streakSavers: 0,
};

export function usePremiumPacks() {
  const [packs, setPacks] = useState<UserPacks>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : defaultPacks;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(packs));
  }, [packs]);

  const addPacks = (type: keyof UserPacks, amount: number) => {
    setPacks(prev => ({
      ...prev,
      [type]: prev[type] + amount,
    }));
  };

  const usePack = (type: keyof UserPacks): boolean => {
    if (packs[type] <= 0) return false;
    
    setPacks(prev => ({
      ...prev,
      [type]: prev[type] - 1,
    }));
    return true;
  };

  return { packs, addPacks, usePack };
}